<template>
  <div
    class="bg"
    style="
      background: linear-gradient(#0009, #0007), url(static/img/background.jpg);
    "
  >
    <v-container grid-list-lg class="mb-5">
      <v-layout row wrap>
        <v-flex xs12 class="text-xs-center">
          <img src="static/logo/logo.svg" width="220" class="mx-auto mt-2" />
        </v-flex>
        <v-flex xs12>
          <h1 class="titulo mt-5">Simuladores</h1>
        </v-flex>
        <v-flex xs12 sm6 md4 v-for="s in simuladores">
          <v-card class="card-custom-two" @click="!s.soon && createUrl(s.link)">
            <v-chip
              color="#68b842"
              class="font-weight-bold"
              style="position: absolute; top: 4px; right: 2px"
              light
              v-if="s.soon"
            >
              <v-icon
                light
                color="rgba(0, 0, 0, 0.7)"
                class="mr-1"
                style="margin-left: -8px"
                >mdi mdi-clock</v-icon
              >
              Em breve</v-chip
            >
            <v-card-text>
              <v-icon color="primary" size="46">{{ s.icon }}</v-icon>
              {{ s.name }}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
let _base;

try {
  _base = require("@/page/_base.vue").default;
} catch (err) {
  _base = require("@/framework/page/_base.vue").default;
}

export default {
  extends: _base,

  data() {
    return {
      simuladores: [
        {
          id: 1,
          name: "Ar Comprimido",
          link: "ar_comprimido",
          icon: "mdi mdi-diving-scuba-tank-multiple",
          soon: false,
        },
        {
          id: 2,
          name: "Bombas (Válvula)",
          link: "motores_inversores_bombas?mode=valvula",
          icon: "mdi mdi-engine",
          soon: false,
        },
        {
          id: 3,
          name: "Bombas (Vazão)",
          link: "motores_inversores_bombas?mode=vazao",
          icon: "mdi mdi-engine",
          soon: false,
        },
        {
          id: 4,
          name: "Caldeira",
          link: "caldeira",
          icon: "mdi mdi-factory",
          soon: false,
        },
        {
          id: 5,
          name: "Iluminação",
          link: "iluminacao",
          icon: "mdi mdi-lightbulb-on",
          soon: false,
        },
        {
          id: 6,
          name: "Refrigeração",
          link: "refrigeracao?mode=chiller",
          icon: "mdi mdi-snowflake",
          soon: false,
        },
        {
          id: 7,
          name: "Subestação",
          link: "subestacao",
          icon: "mdi mdi-transmission-tower",
          soon: false,
        },
        {
          id: 8,
          name: "Ventiladores (Dumper)",
          link: "motores_inversores_ventiladores?mode=dumper",
          icon: "mdi mdi-fan",
          soon: false,
        },
        {
          id: 9,
          name: "Ventiladores (Vazão)",
          link: "motores_inversores_ventiladores?mode=vazao",
          icon: "mdi mdi-fan",
          soon: false,
        },
      ],
    };
  },
  methods: {
    createUrl(item) {
      window.open("#/" + item, "_self");
    },
  },
};
</script>

<style lang="scss">
@import "@/theme/styles/base.scss";

.bg {
  min-height: 100svh;
  min-width: 100svw;
  background-size: cover !important;
  background-attachment: fixed !important;
  background-repeat: no-repeat !important;
}

.titulo {
  text-transform: uppercase;
  font-size: 32px !important;
  background: linear-gradient(
    135deg,
    #009247 0%,
    #8cc640 25%,
    #009247 50%,
    #bcff63 70%,
    #009247 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 150%;
  font-weight: 800 !important;
}

.card-custom-two {
  backdrop-filter: blur(6px) brightness(0.8) !important;
  background: linear-gradient(
    -45deg,
    tint($brand-primary, 90%),
    tint($brand-primary, 96%)
  ) !important;
  border: 2px solid tint($brand-primary, 80%) !important;
  border-radius: 1.4rem !important;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1 / 0.4;
  box-shadow: inset 0 3px 56px tint(#fff, 90%),
    inset 0 3px 156px tint(#fff, 99%) !important;
  cursor: pointer;

  &:hover {
    border-color: $brand-primary !important;
    backdrop-filter: blur(6px) brightness(1.2) !important;
    background: linear-gradient(
      -45deg,
      tint($brand-primary, 80%),
      tint($brand-primary, 86%)
    ) !important;
  }

  .v-card__text {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-weight: 800 !important;
    font-size: 18px !important;
  }
}
</style>
